import {ensureString} from "../../helpers/string-helpers";
import {fromQueryParameters} from "../../helpers/query-parameters-helper";
import {INVALID_REDIRECT_URL} from "../../helpers/constants";

const urls: Record<string, string[]> = {
    //Dev
    '753pbp05bjvu6o6t2del86c7f0': ['http://localhost/sh/pages/policyholder/servicing/iam-landing-page.jsp,',
        'https://webdev.simplyhealth.co.uk/sh/pages/policyholder/servicing/iam-landing-page.jsp'],
    '6nuvbaedk0do02mdkjg6coc21h': ['com.headuplabs://Authenticate'],
    '3npiu7d00fpof5t3hhgvpjjs2p': ['http://localhost'],
    'cric05kspv2bgvogv9ro91592': ['com.simplyhealth://login'],

    //Test
    '4ll886qe2tt4tf4pf2tsjtsfkv': ['http://localhost/sh/pages/policyholder/servicing/iam-landing-page.jsp',
        'https://webtest2.simplyhealth.co.uk/sh/pages/policyholder/servicing/iam-landing-page.jsp'],
    'h5kqihm5lnojeq8e62qigeel4': ['com.headuplabs://Authenticate'],
    '4gjvl4ndjqois0dp52sn18j6gk': ['http://localhost'],
    '3779h2gl2s67gmgqhtcmvohqg6': ['com.simplyhealth://login'],

    //PreProd
    '5qcl144fiu8giukg24q71rt8o2': ['https://test.simplyhealth.co.uk/sh/pages/policyholder/servicing/iam-landing-page.jsp',
        'https://webtest4.simplyhealth.co.uk/sh/pages/policyholder/servicing/iam-landing-page.jsp'],
    '7lkk2m826n2sab8ahgthvmkab9': ['com.headuplabs://Authenticate'],
    '4a3t21ti3j17s4qdtbqio3julh': ['http://localhost'],
    'TODO': ['com.simplyhealth://login'],

    //External Test
    '6v4bqvm1hdfamdrglref2uqmnr': ['https://externaltest.simplyhealth.co.uk/sh/pages/policyholder/servicing/iam-landing-page.jsp',
        'https://webtest5.simplyhealth.co.uk/sh/pages/policyholder/servicing/iam-landing-page.jsp'],
    '2d1ugpqqg1bgkgq4hls8gaavmi': ['com.headuplabs://Authenticate', 'http://localhost'],
    '35ln6p8od3p05ftn11lqliu681': ['http://localhost'],
    '3volkntoj4asclj6dktgc4mkhl': ['com.simplyhealth://login'],

    //Production
    '28okdbsfd0r85nf46obll9gta7': ['https://www.simplyhealth.co.uk/sh/pages/policyholder/servicing/iam-landing-page.jsp'],
    '6okgg8u1k1v1ujo72ght86ud0d': ['uk.co.simplyhealth.headup://Authenticate'],
    '18hfbl3h1jhhkd51ksjcl8c948': ['http://localhost'],
    'TODO2': ['com.simplyhealth://login']
};

function isRedirectCorrect(appClientId: string | null, redirectUrl: string | null) {
    return appClientId && redirectUrl && urls[appClientId] && urls[appClientId].includes(redirectUrl);
}

export function getRedirectUrl(): string {
    let redirectUrl = fromQueryParameters().getRedirectUri();
    let clientId = fromQueryParameters().getAppClientId();
    if (!isRedirectCorrect(clientId, redirectUrl)) {
        throw new Error(INVALID_REDIRECT_URL);
    }
    return ensureString(redirectUrl);
}